export const associatedContentFragment = `fragment associatedContentFragment on AssociatedContent {
    ... on ContentItem  {
        sourceId
        description
        type
        title
        publishedAt
        image {
            aspects {
                ratio16x9 {
                    url
                }
                ratio9x16 {
                    url
                }
            }
        }
        showData {
            name
        }
        media {
            duration
            streamType
            hasCaptions
            aspectRatio
        }
    }
    ... on Image {
        sourceId
        type:__typename
        aspects {
            ratio16x9 {
                url
            }
            ratioCustom {
                url
            }
        }
        credit
        description
        altText
    }
}`;

export const liveStoryUpdateFragment = `fragment liveStoryUpdateFragment on LiveStoryUpdate {
    id
    publishedAt
    title
    body {
        parsed
        associatedContent {
            ...associatedContentFragment
        }
    }
    author {
        name
        title
        url
    }
}`;

export const liveStoryFragment = `fragment liveStoryFragment on ContentItem {
    id
    sourceId
    source
    type
    url
    flag
    title
    deck
    publishedAt
    updatedAt
    image {
        aspects {
            ratio16x9 {
                url
            }
        }
    }
    section {
        tracking {
            contentArea
            subSection1
            subSection2
            subSection3
            subSection4
        },
    },
    body {
        parsed
        associatedContent {
            ...associatedContentFragment
        }
    }
    tags {
        name
        type
    }
    concepts {
        type
        path
    }
}`;
